module.exports = __webpack_public_path__ + "static/media/chevronDown.2488119b.svg";